import { Component, Vue } from "vue-property-decorator";
import { Callback } from "./../types/types";

export const KeyboardCodes: { [key: string]: number } = {
  Enter: 13,
  Esc: 27,
  ArrowUp: 38,
  ArrowDown: 40
};

@Component({})
export default class ComponentName extends Vue {
  private listeners: any[] = [];
  protected keyUp(key: string | number, callback: Callback) {
    const listener = (event: KeyboardEvent) => {
      if (
        event.keyCode === KeyboardCodes[String(key)] ||
        event.keyCode === key
      ) {
        callback(event);
      }
    };
    document.addEventListener("keyup", listener);
    this.listeners.push(listener);
  }

  protected beforeDestroy() {
    this.listeners.forEach(listener =>
      document.removeEventListener("keyup", listener)
    );
  }
}
